<script>
// 导入订单相关组件（使用乘客订单的组件）
import orderRecord from '@/page/order/orderHitchhiking/components/orderRecord.vue'
import orderChat from '@/page/order/orderHitchhiking/components/orderChat.vue'
import orderLine from '@/page/order/orderHitchhiking/components/orderLine.vue'
import orderAudio from '@/page/order/orderHitchhiking/components/orderAudio.vue'

export default {
  name: "hitchhikingDetails",
  components: {
    orderRecord,
    orderChat,
    orderLine,
    orderAudio
  },
  computed: {
    // 获取第一个乘客订单（一个工单对应一个乘客订单）
    passengerOrder() {
      return this.list && this.list.length > 0 ? this.list[0] : null
    },
    // 获取乘客订单ID
    passengerOrderId() {
      return this.passengerOrder ? this.passengerOrder.id : null
    },
    // 适配orderAudio组件的数据格式
    audioRowData() {
      if (this.passengerOrder) {
        return {
          ...this.passengerOrder,
          orderDriverId: this.rowData.id
        }
      }
      return {
        ...this.rowData,
        orderDriverId: this.rowData.id
      }
    }
  },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeName: 'order',
      map: null,
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/driver/hitchRide/detail/" + this.rowData.id,
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 999, // 每页条数
        },
      },
      // 表头
      columns: [
        {prop: "orderNo", label: "订单号", width: 140},
        {prop: "status", label: "订单状态", width: 80},
        {prop: "startPointName", label: "出发地", minWidth: 200},
        {prop: "endPointName", label: "目的地", minWidth: 200},
        {prop: "realPhoneSuffix", label: "乘客信息", width: 130},
        {prop: "poolType", label: "类型", width: 70},
        {prop: "amount", label: "订单金额", minWidth: 80},
        {prop: "commissionAmount", label: "司机收入", minWidth: 80},
        {prop: "message", label: "备注", width: 80},
      ],
      markerBegin: null,
      markerEnd: null,
      list: [],
      audioList: [],
      loading: false,
      mediaSourceOpt: null,
      // 当前播放的录音索引
      currentAudioIndex: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.activeName === 'map') {
        this.initMap()
      }
    })
    this.getAudioFn()
    this.getPassengerOrderList()
  },
  methods: {
    async getAudioFn() {
      const url = '/api/v1/manage/sound/record/' + this.rowData.id
      const {data, code} = await this.$axios.get(url)
      if (code === 1 && data) {
        this.audioList = data.map((item) => {
          return {
            ...item,
            recordUrl: window.configure.qiniuUrl + item.recordUrl
          }
        })



      }
    },
    listBack(list) {
      this.list = list
    },
    // 主动获取乘客订单列表
    async getPassengerOrderList() {
      const url = "/api/v1/manage/order/driver/hitchRide/detail/" + this.rowData.id
      const res = await this.$axios.get(url, { page: 1, size: 999 })
      console.log('API返回数据:', res)
      // API返回格式: { data: [], total } (axios拦截器已处理code)
      if (res && res.data) {
        this.list = res.data
        console.log('乘客订单列表:', this.list)
        console.log('第一个订单完整数据:', JSON.stringify(this.list[0]))
        // 检查可能的ID字段名
        const order = this.list[0]
        if (order) {
          console.log('可能的ID字段:', {
            id: order.id,
            orderId: order.orderId,
            orderNo: order.orderNo,
            hitchRideOrderId: order.hitchRideOrderId
          })
        }
      }
    },
    actionFn({type, row}) {
      switch (type) {
        case "look":
          this.activeName = 'map'
          this.getMarker(row)
          break;
      }
    },
    initMap() {
      this.map = new AMap.Map("work-order-map", {
        // mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        mapStyle: 'amap://styles/117929a1925007df896212a1031807f5',
        animateEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
    },
    tabChange() {
       this.getMarker(this.list[0])
    },
    getMarker(row) {
      if(!row){
        setTimeout(() => {
          this.getMarker(this.list[0])
        }, 1000)
        return
      }
      if (this.markerEnd && this.markerBegin) {
        this.map.remove([this.markerEnd, this.markerBegin])
      }
      let beginContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #4dace2;">
                                <div>上车地点：${row.startPointName}</div>
                            </div>`;
      let endContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #47c147;">
                                <div>下车地点：${row.endPointName}</div>
                          </div>`;
      this.markerBegin = new AMap.Marker({
        position: new AMap.LngLat(row.startPointLng, row.startPointLat),
        icon: require("@/assets/img/markerBegin.png"),
      });
      this.markerBegin.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: beginContent,
        direction: "top",
      });
      this.markerEnd = new AMap.Marker({
        position: new AMap.LngLat(row.endPointLng, row.endPointLat),
        icon: require("@/assets/img/markerEnd.png"),
      });
      this.markerEnd.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: endContent,
        direction: "top",
      });
      this.map.add([this.markerEnd, this.markerBegin])
      this.$nextTick(() => {
        this.map.setFitView([this.markerBegin, this.markerEnd], true, [100, 0, 20, 0]);
      })
    },
    onPlay(index) {
      let audioDom = this.$refs['audioOne' + index][0]
      audioDom.play();
      const audios = document.getElementsByTagName('audio');
      [].forEach.call(audios, function (i) {
        if (i !== audioDom) {
          i.pause();
          i.currentTime = 0;
        }
      })
    },
    async downloadAudio() {
      this.loading = true
      const url = '/api/v1/manage/sound/record/download/all'
      const data = await this.$axios.get(url, {orderDriverId: this.rowData.id}, {responseType: 'blob'})
      const blob = new Blob([data], {type: "application/zip"})
      this.loading = false
      const fileName = `${this.rowData.schedulingNo}_${this.rowData.driverPhone}_${this.$utils.timeFn(new Date().getTime(), 'YYYYMMDDHHmmSS')}.zip`;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = window.URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        window.URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName)
      }
    },
    getStatusType(status) {
      const item = this.$const.HITCHHIKINGWORK.find(value => value.value == status);
      return item ? item.type : 'info';
    },
    getStatusLabel(status) {
      const item = this.$const.HITCHHIKINGWORK.find(value => value.value == status);
      return item ? item.label : status;
    },
    // 切换tab时的处理
    handleTabChange(tab) {
      if (tab.name === 'map') {
        this.$nextTick(() => {
          if (!this.map) {
            this.initMap()
          }
          this.tabChange()
        })
      }
    },
    // 播放上一段录音
    playPrevAudio() {
      if (this.currentAudioIndex > 0) {
        this.currentAudioIndex--
        this.$nextTick(() => {
          const audio = this.$refs['audioOne' + this.currentAudioIndex]
          if (audio && audio[0]) {
            try { audio[0].play() } catch (e) { }
          }
        })
      }
    },
    // 播放下一段录音
    playNextAudio() {
      if (this.currentAudioIndex < this.audioList.length - 1) {
        this.currentAudioIndex++
        this.$nextTick(() => {
          const audio = this.$refs['audioOne' + this.currentAudioIndex]
          if (audio && audio[0]) {
            try { audio[0].play() } catch (e) { }
          }
        })
      }
    },
    // 录音播放结束自动播放下一段
    onAudioEnded() {
      if (this.currentAudioIndex < this.audioList.length - 1) {
        this.playNextAudio()
      }
    }
  }
}
</script>

<template>
  <div class="hitchhikingDetails">
    <el-tabs :lazy="true" v-model="activeName" type="card" @tab-click="handleTabChange">
      <el-tab-pane label="工单详情" name="order">
        <div class="orderContent">
          <div class="formTitle"><span @dblclick="$utils.dblclickCopy">{{ rowData.schedulingNo }}</span> <span style="margin: 0 10px">/</span><el-tag size="small" :type="getStatusType(rowData.status)">{{ getStatusLabel(rowData.status) }}</el-tag></div>
          <div style="height: 12px"></div>

          <el-form label-position="left" label-width="105px">
            <div class="formContent">
              <div class="items">
                <el-form-item label="出发城市">
                  <span class="color-666"> {{ rowData.startCity }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="到达城市">
                  <span class="color-666">{{ rowData.endCity }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="总计金额">
                  <span class="util-money">¥{{ rowData.totalAmount }}</span>
                </el-form-item>
              </div>

              <div class="items">
                <el-form-item label="出发时间">
                  <span class="color-666">{{ rowData.serviceTime | filterTime }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="完成/取消时间">
                  <span class="color-666">{{ rowData.finishTime | filterTime }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="司机收入">
                  <span class="util-money">¥{{ rowData.realTotalFee }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="机构名称">
                  <span class="color-666"> {{ rowData.organizationName }}</span>
                </el-form-item>

              </div>

              <div class="items">
                <el-form-item label="车辆号牌">
                  <span v-if="rowData.licenseNo" :style="getPlateStyle(rowData.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(rowData.licenseNo) }}</span>
                  <span v-else>-</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="司机姓名">
                  <span class="color-666" @dblclick="$utils.dblclickCopy">{{ rowData.driverName }}</span>
                </el-form-item>
              </div>

              <div class="items">
                <el-form-item label="司机手机">
                  <span class="color-666" @dblclick="$utils.dblclickCopy">{{ rowData.driverPhone }}</span>
                </el-form-item>
              </div>


            </div>


          </el-form>

          <div class="formTitle">乘客订单</div>

          <custom-table @listBack="listBack" :paging="false" ref="customTable" :customOptions="customOptions"
                        :columns="columns"
                        style="height: 500px">
            <template slot-scope="{ item, row }">
              <template v-if="item.prop == 'created'">{{ row.created | filterTime }}</template>
              <template v-else-if="item.prop == 'status'">
                <el-tag size="mini" :type="row.status | filterConst('HITCHHIKINGWORKTWO', 'type')">{{ row.status | filterConst('HITCHHIKINGWORKTWO') }}</el-tag>
              </template>
              <template v-else-if="item.prop === 'startPointName'">
                <div>{{ row.startPointName }}</div>
                <div style="color:#999"> {{ row.startCity }}{{ row.startDistrict }}{{ row.startPointAddress }}</div>
              </template>
              <template v-else-if="item.prop === 'endPointName'">
                <div>{{ row.endPointName }}</div>
                <div style="color:#999">{{ row.endCity }}{{ row.endDistrict }}{{ row.endPointAddress }}</div>
              </template>

              <template v-else-if="item.prop == 'amount'">
                <span class="util-money">
                  ¥{{ row.amount || 0 }}
                </span>
              </template>
              <template v-else-if="item.prop == 'realPhoneSuffix'">
                <span>
                  {{ row.realPhoneSuffix }} / {{ row.passengerNum }}人
                </span>
              </template>
              <template v-else-if="item.prop == 'orderNo'">
                <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
              </template>
              <template v-else-if="item.prop == 'commissionAmount'">
                <span class="util-money">
                  ¥{{ row.commissionAmount || 0 }}
                </span>
              </template>

              <template v-else-if="item.prop == 'poolType'">
                <el-tag :type="row.poolType == 1 ? 'primary' : 'success'" size="mini">{{ row.poolType == 1 ? '独享' : '拼车' }}</el-tag>
              </template>
              <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
            </template>

            <template slot="table-operation">
              <el-table-column label="操作" width="100" fixed="right" align="center">
                <div slot-scope="{ row }" class="custom-action">
                  <el-button type="text" @click="actionFn({ type: 'look', row: row })">上下车位置</el-button>
                </div>
              </el-table-column>
            </template>
          </custom-table>
        </div>
      </el-tab-pane>
      
      <el-tab-pane label="地图查看" name="map">
        <div class="flex-start">
          <div id="work-order-map"></div>
        </div>
      </el-tab-pane>

      <!-- 订单跟踪 -->
      <el-tab-pane label="订单跟踪" name="track">
        <orderRecord :orderId="passengerOrderId" v-if="activeName === 'track' && passengerOrderId"></orderRecord>
        <div v-else-if="activeName === 'track'" class="flex-center" style="height: 300px;">
          <el-empty description="暂无订单数据"></el-empty>
        </div>
      </el-tab-pane>

      <!-- 订单轨迹 -->
      <el-tab-pane label="订单轨迹" name="line">
        <orderLine :rowData="passengerOrder" v-if="activeName === 'line' && passengerOrder"></orderLine>
        <div v-else-if="activeName === 'line'" class="flex-center" style="height: 300px;">
          <el-empty description="暂无订单数据"></el-empty>
        </div>
      </el-tab-pane>

      <!-- 行程录音 -->
      <el-tab-pane label="行程录音" name="audio">
        <orderAudio :rowData="audioRowData" v-if="activeName === 'audio' && passengerOrder"></orderAudio>
        <div v-else-if="activeName === 'audio'" class="flex-center" style="height: 300px;">
          <el-empty description="暂无订单数据"></el-empty>
        </div>
      </el-tab-pane>

      <!-- 聊天记录 -->
      <el-tab-pane label="聊天记录" name="chat">
        <div class="blueInfo">
          * 以下为该订单乘客与司机通过司机端App内的聊天工具的建联记录
        </div>
        <orderChat :orderId="passengerOrderId" v-if="activeName === 'chat' && passengerOrderId"></orderChat>
        <div v-else-if="activeName === 'chat'" class="flex-center" style="height: 300px;">
          <el-empty description="暂无订单数据"></el-empty>
        </div>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<style scoped lang="less">
.hitchhikingDetails {
  padding: 20px;
  height: calc(100vh - 40px);
  overflow-y: auto;
  
  /deep/ .el-tabs {
    height: 100%;
    
    .el-tabs__header {
      margin-bottom: 16px;
    }
    
    .el-tabs__content {
      height: calc(100% - 60px);
      overflow-y: auto;
      
      .el-tab-pane {
        height: 100%;
      }
    }
  }

  #order-map {
    width: 100%;
    height: calc(100vh - 180px);
    min-height: 600px;
  }

  .orderContent {
    .formTitle {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      padding: 12px 0;
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
  }

  .formContent {
    display: flex;
    flex-wrap: wrap;

    .items {
      width: 32%;
      margin-right: 1%;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }

  // 行程录音样式
  .audio-container {
    padding: 20px;
    background: #f8fafc;
    border-radius: 12px;
    
    .audio-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      
      .audio-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
        
        strong {
          color: #409EFF;
        }
        
        .audio-time {
          font-size: 13px;
          color: #666;
        }
      }
    }
    
    .audio-player {
      display: flex;
      align-items: center;
      background: #fff;
      padding: 16px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
  }

  // 乘客订单详情样式
  .order-detail-container {
    .order-detail-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      background: linear-gradient(135deg, #f0f7ff 0%, #fff 100%);
      border-radius: 8px;
      margin-bottom: 16px;
      
      .order-info {
        display: flex;
        align-items: center;
        gap: 12px;
        
        .order-no {
          font-size: 14px;
          color: #333;
          
          strong {
            color: #409EFF;
            cursor: pointer;
          }
        }
      }
    }
    
    .order-detail-tabs {
      /deep/ .el-tabs__header {
        margin-bottom: 16px;
      }
    }
    
    .order-line-container {
      height: calc(100vh - 280px);
      min-height: 500px;
    }
    
    .chat-container {
      .blueInfo {
        padding: 12px 16px;
        background: #e6f7ff;
        border: 1px solid #91d5ff;
        border-radius: 6px;
        color: #1890ff;
        font-size: 13px;
        margin-bottom: 16px;
      }
    }
  }

  // 蓝色提示信息
  .blueInfo {
    padding: 12px 16px;
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    color: #1890ff;
    font-size: 13px;
    margin-bottom: 16px;
  }
}
</style>